import React from "react";


import {
    BlackoutComponent
} from "@Elements/Content";


import QyvoStandaloneLogo from "@Images/qyvo-standalone-logo-md.svg";


import "./index.scss";


interface DefaultLoaderComponentProps {
    defaultLoaderText?: string;
}


export const DefaultLoaderComponent:React.FC<DefaultLoaderComponentProps> = ({
    defaultLoaderText
}) => {

    return (
        <BlackoutComponent>

            <div className={'default-loader-component'}>

                <img src={QyvoStandaloneLogo} alt={''} className={'default-loader-component__loader-image'}/>

                {defaultLoaderText &&
				    <span className={'default-loader-component__loader-text'}>{defaultLoaderText}</span>
                }

            </div>

        </BlackoutComponent>
    );

};


export default DefaultLoaderComponent;
